import { BaseSerializer } from './base.serializer'
import { Center } from 'models/center.model'
import { CenterOnlineLearningRepeatExamSetting } from 'models/center-online-learning-repeat-exam-setting.model'
import { CenterProgramSerializer } from './center-program.serializer'
import { CenterRepeatExamSettingSerializer } from './center-repeat-exam-setting.serializer'
import { PhotoSerializer } from './photo.serializer'
import { CenterRegistrationSectionSerializer } from './center-registration-section.serializer'
import { AppLocaleSerializer } from './app-locale.serializer';
import { HubSerializer } from './hub.serializer'

export class CenteronlineLearningRetakeExamSettingserializer extends BaseSerializer<CenterOnlineLearningRepeatExamSetting> {
  static SERIALIZABLE_ATTRIBUTES = ['id', 'course', 'grade', 'source', 'programId', 'centerId', '_destroy']
  static SERIALIZERS = {}
  static SERIALIZE_RENAME_KEYS = {}

  static DESERIALIZERS = {}
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): CenterOnlineLearningRepeatExamSetting {
    return new CenterOnlineLearningRepeatExamSetting(attributes)
  }
}

export class CenterSerializer extends BaseSerializer<Center> {
  static SERIALIZABLE_ATTRIBUTES = [
    'cityId', 'comment', 'images', 'infractionIds', 'mobile', 'name',
    'password', 'schedule', 'yandexName', 'repeatExamSettings', 'registrationSections', 
    'centerPrograms', 'contactPersonId', 'cropDriverPhoto', 'interviewInfractionIds',
    'interviewCapacity', 'onlineLearningRetakeExamSettings', 'licenseAgreement',
    'licenseAgreementTitle', 'availableLocales', 'availableLocaleIds', 'hubRedirectSettings',
    'hubs', 'courseMapingSettings', 'smsConfirmation', 'default'
  ]
  static SERIALIZERS = {
    images: PhotoSerializer,
    repeatExamSettings: CenterRepeatExamSettingSerializer,
    registrationSections: CenterRegistrationSectionSerializer,
    centerPrograms: CenterProgramSerializer,
    onlineLearningRetakeExamSettings: CenteronlineLearningRetakeExamSettingserializer
  }
  static SERIALIZE_RENAME_KEYS = {
    images: 'imagesAttributes',
    repeatExamSettings: 'repeatExamSettingsAttributes',
    registrationSections: 'registrationSectionsAttributes',
    centerPrograms: 'centerProgramsAttributes',
    onlineLearningRetakeExamSettings: 'onlineLearningRetakeExamSettingsAttributes'
  }

  static DESERIALIZERS = {
    centerPrograms: CenterProgramSerializer,
    images: PhotoSerializer,
    repeatExamSettings: CenterRepeatExamSettingSerializer,
    registrationSections: CenterRegistrationSectionSerializer,
    onlineLearningRetakeExamSettings: CenteronlineLearningRetakeExamSettingserializer,
    availableLocales: AppLocaleSerializer,
    hubs: HubSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): Center {
    return new Center(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/center.serializer.ts